import OnboardingCoachmark from '../OnboardingCoachmark';
import { AccountSetupOnboardingCoachmarkProps } from './types';
import { onboardingTargetIds } from '../../model/onboardingTargetIds';

const descriptionByVariant = {
  EMAIL: 'Подтвердите свою электронную почту.',
  EMAIL_AND_ORGANIZATION: 'Подтвердите свою электронную почту и добавьте организацию.',
  ORGANIZATION: 'Добавьте организацию для работы с поставками и документами.'
} as const;

const AccountSetupOnboardingCoachmark = (props: AccountSetupOnboardingCoachmarkProps) => {
  const {
    isOpen,
    onClose,
    onNext,
    stepNumber,
    totalSteps,
    variant
  } = props;

  return (
    <OnboardingCoachmark
      description={descriptionByVariant[variant]}
      isOpen={isOpen}
      isTargetInteractive
      onClose={onClose}
      onPrimaryAction={onNext}
      placement="bottom"
      shouldShowBack={false}
      stepNumber={stepNumber}
      targetId={onboardingTargetIds.accountSetup}
      title="Завершите настройку"
      totalSteps={totalSteps}
    />
  );
};

export default AccountSetupOnboardingCoachmark;